<template>
  <div class="appointment">
    <el-tabs v-model="name">
      <el-tab-pane label="基本配置" name="1">
        <invitation @next="next" :form.sync="baseSetting" :uuid="uuid"></invitation>
      </el-tab-pane>
      <el-tab-pane label="表单填写" name="2">
        <invitation-form :form.sync="inForm" @submit="submit" :isedit="edit"></invitation-form>
      </el-tab-pane>
      <el-tab-pane label="可选项" name="3">
        <selectable :form.sync="selectable" @submit="submit"></selectable>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import invitation from './components/invitation'
import invitationForm from './components/invitationForm'
import selectable from './components/selectable'
import request from '@/utils/request'
export default {
  name: 'appointment',
  components: {
    invitation,
    invitationForm,
    selectable
  },
  props: {
    uuid: {
      type: String
    }
  },
  data () {
    return {
      name: '1',
      baseSetting: {
        title: '',
        thumb: '',
        time: '',
        address: '',
        price: '',
        page: {
          style: {
            padding: 0
          },
          modules: []
        }
      },
      inForm: {
        images: [],
        options: {
          email: {
            show: 0
          },
          address: {
            show: 0
          }
        },
        description: '',
        sessions: [],
        is_need_pay: 0
      },
      selectable: {
        book_button_text: '立即预约',
        share_title: '邀请函',
        share_thumb: '',
        submit_button_text: '确定信息并预约',
        review_link: {},
        review_path: ''
      },
      edit: false
    }
  },
  watch: {
    uuid: {
      handler (value) {
        if (value) {
          this.edit = true
          this.getBookingDetail(value)
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getBookingDetail (uuid) {
      request({
        url: '/bookings/' + uuid
      }).then(res => {
        let booking = res.data.booking
        this.baseSetting = {
          title: booking.title,
          page: booking.page,
          thumb: booking.thumb,
          time: booking.time,
          address: booking.address,
          price: booking.price
        }
        let sessions = []
        booking.sessions.forEach(item => {
          sessions.push({
            name: item.name, // 场次名称
            day: item.day, // 天日期
            start_time: item.start_time, // 开始时分
            end_time: item.end_time, // 结束时分
            min_people: item.min_people, // 最小预约人数
            max_people: item.max_people, // 最大预约人数
            stock: item.stock, // 库存
            price: item.price / 100, // 100元/人, 单位分
            id: item.id,
            bookable_before_at: item.bookable_before_at,
            // time: item.time,
            // thumb: item.thumb,
            // address: item.address,
            // price: item.price,
          })
        })
        this.inForm = {
          images: booking.images,
          options: booking.options,
          description: booking.description,
          sessions: sessions,
          is_need_pay: booking.is_need_pay,
          // thumb: booking.thumb,
          // time: booking.time,
          // address: booking.address,
          // price: booking.price
        }
        this.selectable = {
          book_button_text: booking.book_button_text,
          share_title: booking.share_title,
          share_thumb: booking.share_thumb,
          submit_button_text: booking.submit_button_text,
          review_link: booking.review_link,
          review_path: booking.review_path
        }
        console.log(booking)
      })
    },
    next () {
      this.name = '2'
    },
    submit () {
      let inform = JSON.parse(JSON.stringify(this.inForm))
      inform.sessions.forEach(item => {
        item.price = (item.price * 100) || 0
      })
      if (!this.edit) {
        request({
          url: '/bookings',
          method: 'post',
          data: {
            ...this.baseSetting,
            ...inform,
            ...this.selectable
          }
        }).then(res => {
          this.$message.success('创建成功!')
          this.$router.push({
            path: '/booking/list'
          })
        })
      } else {
        request({
          url: '/bookings/' + this.uuid,
          method: 'patch',
          data: {
            type: 'update',
            attributes: {
              ...this.baseSetting,
              ...inform,
              ...this.selectable
            }
          }
        }).then(res => {
          this.$message.success('更新成功!')
          this.$emit('update-success')
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/views/booking/index.vue